import type { Product, ProductLink } from 'models/product';
import { getMainImageDetail, getProductImage } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';

import BasePicker from './BasePicker';

interface Props {
	buttonText: string;
	className?: string;
	product: Product;
	variants: ProductLink[] | undefined;
	variantTitle: string;
}

export default function StylePicker({
	buttonText,
	className,
	product,
	variants,
	variantTitle,
}: Props) {
	return (
		<BasePicker
			className={className}
			buttonLabel={buttonText}
			popoverTitle={variantTitle}
			selectedText={
				variants?.find((variant) => variant.productId === product.productId)
					?.title
			}
			selectedImageUrl={getMainImageDetail(product)?.src}
			variants={filterTruthy(variants, 'url').map((variant) => {
				const image = getProductImage(variant);
				return {
					imageSrc: image?.src,
					imageAlt: image?.alt,
					isSelected: variant.productId === product.productId,
					key: variant.productId,
					title: variant.title,
					url: variant.url,
				};
			})}
		/>
	);
}
StylePicker.displayName = 'ProductDetails_StylePicker';
